import moment from 'moment';
import React from 'react';

function Timer(props) {
  const [time, setTime] = React.useState(moment().format("H:mm:ss"));

  React.useEffect(() => {
    setInterval(() => {
      setTime(moment().format("H:mm:ss"));
    }, 1000);
  }, [time]);
  return (
    <>
      <h1 className="text-primary text-center mb-1">
        {moment().format("yyyy/MM/DD")}
      </h1>
      <h1 className="text-primary text-center mb-3">{time}</h1>
    </>
  );
}

export default Timer;